// themes/colors.ts
export const roleColors:any = {
    user: {
      background: "#f5f8ff",  
      cardBg: "#ffffff",
      cardBorder: "#cbd5e0",
      text: "#1a202c",
    },
    admin: {
      background: "#1a202c",  
      cardBg: "#2d3748",
      cardBorder: "#4a5568",
      text: "#f7fafc",
    },
    manager: {
      background: "#064e3b",  
      cardBg: "#065f46",
      cardBorder: "#047857",
      text: "#ecfdf5",
    },
  };
  